import { DocumentLink } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/DocumentLink';
import { ErrorContent } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/ErrorContent';
import { LanguageLink } from 'components/common-form/sidePanel/docToolbar/regulatory/design-system/LanguageLink';
import { GenerationFailedError } from 'components/shared/Blotter/BlotterPanel/blotter-panel-document/hooks';
import { DocumentItem } from 'epic/common-form/Documentation';
import { useDownloadMarketingMaterials } from 'hooks/useDownloadMarketingMaterials';
import { useTranslation } from 'hooks/useTranslation';
import type { BlotterAnalyticCategory } from 'models/analytics';
import type { IBlotterItem } from 'models/IBlotterItem';
import { logAnalytics } from 'shared/middlewares/analytics/logger';

type Props = {
  items: DocumentItem[];
  blotterItem: IBlotterItem;
  analyticsCategory: BlotterAnalyticCategory | undefined;
};

export function MarketingMaterialDocuments({ items, blotterItem, analyticsCategory }: Props) {
  const label = useTranslation('blotterPanel.MarketingMaterialsDownload');
  const { isDownloading, download, error } = useDownloadMarketingMaterials();

  return (
    <DocumentLink label={label}>
      {items.map((doc, index) => {
        if (isDownloading || doc.status === 'Pending') {
          return <LanguageLink key={index} langCode={doc.language} status="pending" />;
        }
        if (error !== undefined || doc.status === 'Generation failed') {
          return (
            <LanguageLink key={index} langCode={doc.language} status="error" severity="warning" onShowError={null}>
              <ErrorContent error={error ?? GenerationFailedError} severity="warning" />
            </LanguageLink>
          );
        }
        return (
          <LanguageLink
            key={index}
            langCode={doc.language}
            status="success"
            onDownload={() => {
              if (analyticsCategory !== undefined) {
                logAnalytics.trackEvent(analyticsCategory, 'Download marketing materials', doc.language);
              }
              download(blotterItem.productId, blotterItem);
            }}
          />
        );
      })}
    </DocumentLink>
  );
}
